module.exports = __webpack_public_path__ + "img/quest_visualization_quest_pending_8.2994f48a.svg";